module.exports = __webpack_public_path__ + "img/im.46d995f.svg";